//@ts-nocheck
import { EditIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Formik } from "formik";
import { observer } from "mobx-react-lite";
import { object, string } from "yup";
import { FFormField } from "../primitives/landing-pages";
import { toTitleCase } from "../utils/functions";
import certificationData from "./formData/certification.json";

const workHistoryInitialValue = {
  name: "",
  institution: "",
};

const CertificationFormRaw = (props: any) => {
  const { value, onSubmit, showFormError, innerRef } = props;
  const { validationData } = certificationData;

  const workValidationSchema = object().shape({
    institution: string().required(validationData.institution.required),
    name: string().required(validationData.name.required),
  });

  return (
    <Formik
      validationSchema={workValidationSchema}
      innerRef={innerRef as any}
      initialValues={{ ...workHistoryInitialValue, ...value }}
      onSubmit={(values) => {
        let newValues = {
          ...values,
          institution: toTitleCase(values.institution),
          name: toTitleCase(values.name),
        };
        onSubmit(newValues);
      }}
    >
      {({ values, handleSubmit, handleBlur }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Stack spacing={6}>
              {showFormError && (
                <Box pt={2}>
                  <Alert rounded="lg" status="error">
                    <AlertIcon />
                    {certificationData.formTitle.errorMessage}
                  </Alert>
                </Box>
              )}
              <FFormField name="institution" />
              <FFormField name="name" />
            </Stack>
          </form>
        );
      }}
    </Formik>
  );
};

export const CertificationForm = observer(CertificationFormRaw);

export const Certification = ({
  field: certification,
  onEdit,
  ...rest
}: {
  field: any;
  onEdit: any;
}) => {
  const { name, institution } = certification;

  return (
    <Box>
      {institution && (
        <Flex justify="space-between" align="baseline">
          <Box flex={1}>
            <Text fontWeight="semibold">{name}</Text>
            <Text>{institution}</Text>
          </Box>

          <Stack ml={[3, 6]} align="center">
            <Button
              size="sm"
              leftIcon={<EditIcon />}
              variant="link"
              colorScheme="blue"
              onClick={onEdit}
            >
              Edit
            </Button>
          </Stack>
        </Flex>
      )}
    </Box>
  );
};
